module.exports = __webpack_public_path__ + "img/Facebook_icon_2013.svg.42d848a4.png";